import { ArcadeComponentMigrationConfig, ArcadeComponentMigrationFlags } from '../FeatureFlags'
import { useFeatureFlag } from './useFeatureFlag'

export type ArcadeComponentType = ArcadeComponentMigrationFlags extends `cash-web-arcade-migration-${infer Component}`
  ? Component
  : never

export const useArcadeMigrationFeatureFlag = (component: ArcadeComponentType) => {
  const arcadeMigrationFeatureFlag = useFeatureFlag('cash-web-arcade-migration')
  const flag = `cash-web-arcade-migration-${component}` as keyof ArcadeComponentMigrationConfig

  return arcadeMigrationFeatureFlag?.[flag] === 'ENABLED'
}
